import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/auth/AuthProvider";
import type { AppRole } from "@/core/auth/roles";
import { getDocumentationSidebarEntries } from "@/features/documentation/config";

export function useDocumentationPermissions() {
  const { roles } = useAuth();
  const roleList = roles.map((item) => item.role as AppRole);

  return useQuery({
    queryKey: ["documentation-permissions", roleList.slice().sort().join(",")],
    queryFn: async () => getDocumentationSidebarEntries(roleList),
  });
}
